export default __webpack_public_path__ + "static/media/users_2.fb91a89e.png";